<template>

    <v-layout row wrap>
        <v-flex xs12 sm6 offset-sm3>



            <h1 class="pa-2">カード決済</h1>
            <h3 class="pa-2">ご利用いただけるカードは、Visa, Master, American Expressです。</h3>


                    <div id="manual-payment-elements"
                         v-bind:class="{'d-block':showManualPayButton,'d-none':!showManualPayButton}"
                         class="text-xs-left pa-2"
                    >
                        <p>カード番号、有効期限(年/月)、CVC番号(カード裏面の3桁数字、AMEXは表面の4桁数字)を入力してください。</p>
                        <img :src="require('../assets/cardBrands/1.png')" width="50px" />
                        <img :src="require('../assets/cardBrands/2.png')" width="50px" />
                        <img :src="require('../assets/cardBrands/22.png')" width="50px" />

                        <v-layout row wrap class="text-xs-left el-inputs">
                            <v-flex xs12 class="pa-3">カード番号:<div id="el-cardnumber"></div></v-flex>
                            <v-flex xs6 class="pa-3">有効期限<br/><div id="el-exp"></div></v-flex>
                            <v-flex xs6 class="pa-3">裏面3桁/Amex表4桁<br/><div id="el-cvc"></div></v-flex>

                        <!-- Used to display Element errors. -->
                            <v-flex xs12 >
                                <div id="card-errors" role="alert" style="color:#ff5252;"></div>
                            </v-flex>
                            <v-flex xs10 offset-xs1>
                                <v-btn block color="orange" dark class="mb-5" @click.stop="payByManual" :loading="sendingServer">お支払い実行</v-btn>
                            </v-flex>
                        </v-layout>
                        <div id="manual-button-errors" style="color:#ff5252;"></div>
                        <v-btn
                                flat
                                small
                                color="primary"
                                @click="hideManualPayButton"
                                v-if="paymentRequestButtonAvailable && !applePayButtonOn"
                        >
                            保存された支払い情報を利用
                        </v-btn>
                        <div v-if="!paymentRequestButtonAvailable">
                            <div>iPhoneやiPadではApplePayを使うと、カード番号の入力の手間が無くなります。
                            <a href="https://support.apple.com/ja-jp/HT204506" target="_blank">ApplePayについて</a>
                            </div>
                            <div>AndroidおよびChromeブラウザではGooglePayが使えます。
                                <a href="https://support.google.com/pay/answer/7625055?co=GENIE.Platform%3DAndroid&hl=ja" target="_blank">
                                GooglePayについて</a>
                            </div>
                        </div>

                    </div>



                    <div class="text-xs-center"
                         id="applepay-payment-elements"
                         v-bind:class="{'d-block':showApplePayButton,'d-none':!showApplePayButton}"
                    >
                        <v-flex xs10 offset-xs1 mb-5 >
                            <div id="payment-request-button">
                                <!-- A Stripe Element will be inserted here. -->
                            </div>
                            <h5 class="text-xs-center">上のボタンを押すと、お支払い決済を実行します</h5>
                            <div id="apple-button-errors" style="color:#ff5252;"></div>
                            <v-btn
                                    flat
                                    small
                                    color="primary"
                                    v-if="paymentRequestButtonAvailable && applePayButtonOn"
                                    @click="hideAppleButton">
                                カード情報を手入力する
                            </v-btn>
                        </v-flex>
                    </div>

                    <div id="sendingServerProgress" v-bind:class="{'d-block':sendingServer,'d-none':!sendingServer}">
                        <p >サーバーにデータを送信中です。このままお待ちください。画面の再読み込みなどはしないでください。</p>
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </div>

<div>
    <v-alert
            dense
            outline
            icon="warning"
            :value="true"
            class="mx-3"
    >
        次の場合でも返金はできません。上記のお支払いボタンを押すことで、以下にご同意いただいたものといたします。
        <ul>
            <li>お客さまが来店されなかった場合</li>
            <li>お客さまがお約束の場所・時間におられなかった場合</li>
            <li>衛生上の観点からお約束時間から1時間を経過した時点で、商品を処分いたします。この場合でも返金はいたしません。</li>
        </ul>
    </v-alert>
</div>

        </v-flex>

    </v-layout>

</template>

<script>
    import  { Logger } from 'aws-amplify';
    const logger = new Logger('Checkout','INFO');
    import { AmplifyEventBus } from 'aws-amplify-vue'
    import { uuid } from 'vue-uuid';
    //import moment from 'moment-timezone'
    import {PriceMixIns} from '../mixins/price'
    //import CheckoutHelper from '../components/CheckoutHelper'

    export default {
        mixins:[PriceMixIns],
        //components:{'CheckoutHelper':CheckoutHelper},
        data () {
            return {
                cart:{items:[]},
                cognitoId:'',
                totalPrice:0,
                feeTotal:0,
                lang:"",
                currency:"",
                panel:0,
                todayDate:"7月25日",
                userSelect:{
                    service:{
                        name:"",
                        langName:""
                    }
                },
                selectDisplay:{
                    service:{
                        color:{
                            adt:"default",
                            pickUp:"default",
                            dineIn:"default"
                        }
                    }
                    },
                paymentRequest: null,
                setupPaymentButtonDone: false,
                paymentRequestButtonAvailable: true,
                applePayButtonOn: false,
                showApplePayButton: true,
                showManualPayButton: false,
                sendingServer: false,
                businessHours: undefined,
                cardNumber:undefined
            }
        },
        created(){
            //console.log("created")
            AmplifyEventBus.$on('cartCurrent',this.cartCurrent)
            AmplifyEventBus.$on("currentUserSelect",this.currentUserSelect)
            AmplifyEventBus.$on("cognitoId",this.cognitoIdReceived)
        },
        beforeDestroy () {
            logger.info("Checkout beforeDestroy")
            AmplifyEventBus.$off('cartCurrent',this.cartCurrent)
            AmplifyEventBus.$off("currentUserSelect",this.currentUserSelect)
            AmplifyEventBus.$off("cognitoId",this.cognitoIdReceived)
        },
        async mounted() {
            AmplifyEventBus.$emit('setBackTo', "/setDateTimeMethod")
            AmplifyEventBus.$emit('getUserSelect')
            AmplifyEventBus.$emit('getCart')
            AmplifyEventBus.$emit('getCognitoId')

            this.$gtag.event('conversion', {'send_to': 'AW-736955098/RUvECKC0h9kBENqVtN8C'});


logger.info("shopName",this.$store.state.shopName)
        },
        computed:{


        },
        methods: {
            // Create an array the length of our items
            // with all values as true
            cardClicked:function(){
                console.log("card clicked")
            },
            validation:function(){
                return true
            },
            cognitoIdReceived:function(data){
                logger.info("cognitoId",data)
                this.cognitoId = data
            },
            cartCurrent:function(data){
                //console.log(cart)
                console.log("cartCurrent")
                this.cart = data.cart
                this.lang = this.cart.lang
                this.currency = this.cart.currency
                this.totalPrice = this.cart.total
                this.feeTotal = this.cart.feeTotal
                this.businessHours = data.businessHours
                if(this.currency == "JPY"){
                    this.totalPrice = Math.round(this.cart.total)
                }else{
                    this.totalPrice = Math.round(this.cart.total * 100) / 100
                }
                logger.info("totalPrice",this.totalPrice)

                this.totalPriceCurrency = this.getCurrencyFormatted(this.totalPrice);
                // update paymentRequest
                if(!this.setupPaymentButtonDone && !this.paymentRequest){
                    logger.info("setting up payment button")
                    this.setupPaymentButtons()
                    this.setupPaymentButtonDone = true
                }else{
                    // actually total amount is updated on Submit
                    this.paymentRequest.update({
                        total: {
                            label: this.$store.state.shopName,
                            amount: this.totalPrice,
                        }
                    })
                }
                AmplifyEventBus.$emit('setJourney', {key:"page",value:"決済ページ"} )
                AmplifyEventBus.$emit('setJourney', {key:"cart",value:this.cart } )
                // business hours


            },
            setupPaymentButtons:function(){
                console.log("setupPaymentButtons")
                this.trackPage('/checkout/paymentButton')
                logger.info("testMode",this.$store.state.testMode)
                if(location.hostname == "localhost" || this.$store.state.testMode ) {
                    // eslint-disable-next-line
                    this.stripe = Stripe('pk_test_mTxdyDruuDWRDP3rpMuYWv6200Bq6E9WIn')
                    logger.info("test")
                }else{
                    // eslint-disable-next-line
                    this.stripe = Stripe('pk_live_wjUEveLZag0xcVCnoBqgv6pW00uOtDYEzU')
                    logger.info("live")
                }
                const elements = this.stripe.elements();
                // Custom styling can be passed to options when creating an Element.

                // payment request button
                const self = this
                this.paymentRequest = this.stripe.paymentRequest({
                    country: 'JP',
                    currency: 'jpy',
                    total: {
                        label: this.$store.state.shopName,
                        amount: this.totalPrice,
                    },
                });

                const prButton = elements.create('paymentRequestButton', {
                    paymentRequest: this.paymentRequest,
                    style:{
                        paymentRequestButton: {height:'64px'}
                    }
                });

                if(this.cart.items.length>0){
                    this.paymentRequest.canMakePayment().then(function(result) {
                        self.createCardManual(elements)
                        if (result) {
                            prButton.mount('#payment-request-button');
                            self.paymentRequestButtonAvailable = true
                            self.applePayButtonOn = true
                            self.showManualPayButton = false
                            self.showApplePayButton = true
                        } else {
                            self.paymentRequestButtonAvailable = false
                            self.applePayButtonOn = false
                            self.showManualPayButton = true
                            self.showApplePayButton = false

                        }
                        logger.info("paymentRequest result",result)
                        console.log("paymentRequestButtonAvailable is "+JSON.stringify(self.paymentRequestButtonAvailable))
                    }).catch(err=>{
                        logger.info("paymentRequest err",err)
                    });

                    this.paymentRequest.on('token', async (ev) => {
                        // Send the token to your server to charge it!
                        //ev.preventDefault()
                        //console.log(ev)
                        //console.log(ev.token)

                        self.sendingServer = true

                        const response = await self.submitServer(ev.token).catch(err =>{
                            console.log(err)
                            ev.complete('fail');
                            self.sendingServer = false

                        });
                        console.log(response.data)
                        if(response.data.result && response.data.result == "success"){
                            this.sendingServer = false
                            const purchaseObj = {currency:"JPY",value:this.totalPrice}
                            this.fbTrack('Purchase',purchaseObj)
                            this.trackPage('/checkout/?result=success')
                            AmplifyEventBus.$emit('setJourney', {key:"checkout",value:"成功"} )
                            AmplifyEventBus.$emit('addOrder',response.data)
                            const orderId = response.data.orderId
                            this.$router.push('/orderDetail/?orderId='+orderId)
                            ev.complete('success');
                        }else{
                            this.sendingServer = false
                            const appleButtonErrorMessage = document.getElementById("apple-button-errors")
                            appleButtonErrorMessage.textContent = "カード決済ができませんでした。"
                            this.trackPage('/checkout/?result=err_transaction')
                            AmplifyEventBus.$emit('setJourney', {key:"checkout",value:"決済エラー"} )
                            ev.complete('fail');
                        }

                    });
                    this.paymentRequest.on('cancel', async (ev) => {
                        // Send the token to your server to charge it!
                        console.log("payment cancel detected")
                        console.log(ev)
                    });
                }
                prButton.on("click",function(e){
                    console.log("prButton Clicked")
                    //const validationResult = this.validation()
                    const validationResult = "ok"
                    //console.log("validationResult: "+validationResult)
                    const appleButtonErrorMessage = document.getElementById("apple-button-errors")
                    if(validationResult!="ok"){
                        e.preventDefault();
                        console.log("validation error preventDefault")
                        appleButtonErrorMessage.textContent = "入力内容にエラーまたは不足があります。赤くなっている部分を修正の上、再度お試しください。"
                    }else{
                        appleButtonErrorMessage.textContent = ""
                    }
                })

            },
            createCardManual:function(elements){

                // Custom styling can be passed to options when creating an Element.
                const style = {

                    base: {
                        // Add your base input styles here. For example:
                        fontWeight: 500,
                        fontSize: '20px',
                        color: "#32325d",
                        '::placeholder': {
                            color: '#CFD7DF',
                        },
                    },
                };


                // el-cardnumber el-cvc el-exp
                const elementClasses = {
                    focus: 'focused',
                    empty: 'empty',
                    invalid: 'invalid',
                };

                this.cardNumber = elements.create('cardNumber', {
                    style: style,
                    classes: elementClasses,
                });
                this.cardNumber.mount('#el-cardnumber');

                const cardExpiry = elements.create('cardExpiry', {
                    style: style,
                    classes: elementClasses,
                });
                cardExpiry.mount('#el-exp');

                const cardCvc = elements.create('cardCvc', {
                    style: style,
                    classes: elementClasses,
                });
                cardCvc.mount('#el-cvc');


                this.cardNumber.addEventListener('change', ({error}) => {
                    const displayError = document.getElementById('card-errors');
                    if (error) {
                        displayError.textContent = error.message;
                    } else {
                        displayError.textContent = '';
                    }
                })



            },
            submitServer:async function(token){
                const dataToSend = {}
                dataToSend["submit_uuid"]="submit_" + uuid.v4()
                dataToSend["stripeToken"]=token
                dataToSend["hostname"]=location.hostname
                dataToSend.cognitoId = this.cognitoId
                if(this.$store.state.testMode){
                    dataToSend["testmode"] = "test"
                }
                const keyToSend=["cart","totalPrice","feeTotal","lang","currency","userSelect"]
                for(let i in keyToSend){
                    let key = keyToSend[i]
                    dataToSend[key] = this.$data[key]
                }

                logger.info("submitServer dataToSend",dataToSend)
                const url="https://rjq6wkfhwd.execute-api.ap-northeast-1.amazonaws.com/default/stripe_adt/chargesConnect/"
                const submitRes = await this.axios.post(url,{dataToSend})
                if(submitRes.data.result == "success"){
                    const ordersExist = localStorage.getItem("orders")
                    let orders = []
                    if(ordersExist){
                        orders = JSON.parse(localStorage.getItem("orders"))
                    }
                    orders.push(submitRes.data)
                    localStorage.setItem('orders',JSON.stringify(orders))
                }

                return submitRes
            },
            payByManual:async function(e){
                console.log("payByManual")
                e.preventDefault()
                this.sendingServer = true
                const validationResult = this.validation()
                console.log("validationResult: "+validationResult)
                const manualButtonErrorMessage = document.getElementById("manual-button-errors")
                AmplifyEventBus.$emit('setJourney', {key:"checkout",value:"カード番号手入力"} )
                if(validationResult){
                    const {token, error} =  await this.stripe.createToken(this.cardNumber);//this.card
                    if (error) {
                        // Inform the customer that there was an error.
                        const errorElement = document.getElementById('card-errors');
                        errorElement.textContent = error.message;
                        manualButtonErrorMessage.textContent = "カード情報にエラーがあります。入力内容を再度ご確認ください。"
                        AmplifyEventBus.$emit('setJourney', {key:"checkout",value:"カードエラー"} )
                        AmplifyEventBus.$emit('setJourney', {key:"carderror",value:error} )
                        if(error.decline_code && error.decline_code == "card_not_supported"){
                            manualButtonErrorMessage.textContent = "対応していないカードです。VISA/Master/AMEXのカードをご利用ください。"
                            errorElement.textContent += " 当サービスはJCBには対応していません。";
                            this.trackPage('/checkout/?result=error_card_jcb')
                            AmplifyEventBus.$emit('setJourney', {key:"checkout",value:"JCBなど未サポートカードが入力されたエラー"} )
                        }else{
                            this.trackPage('/checkout/?result=error_card')
                        }
                        this.sendingServer = false
                    } else {
                        manualButtonErrorMessage.textContent = ""


                        const response = await this.submitServer(token);
                        console.log(response.data)
                        if(response.data.result && response.data.result == "success"){
                            this.sendingServer = false
                            const purchaseObj = {currency:"JPY",value:this.totalPrice}
                            this.fbTrack('Purchase',purchaseObj)
                            this.trackPage('/checkout/?result=success')
                            AmplifyEventBus.$emit('setJourney', {key:"checkout",value:"成功"} )
                            AmplifyEventBus.$emit('addOrder',response.data)
                            const orderId = response.data.orderId
                            this.$router.push('/orderDetail/?orderId='+orderId)
                        }else{
                            this.sendingServer = false
                            manualButtonErrorMessage.textContent = "カード決済ができませんでした。"
                            this.trackPage('/checkout/?result=err_transaction')
                            AmplifyEventBus.$emit('setJourney', {key:"checkout",value:"決済エラー"} )
                        }

                    }
                }else{
                    manualButtonErrorMessage.textContent = "入力内容にエラーまたは不足があります。赤くなっている部分を修正の上、再度お試しください。"
                    this.sendingServer = false
                }

            },
            hideAppleButton:function(){
                console.log("hideAppleButton")
                this.applePayButtonOn = false
                this.showManualPayButton = true
                this.showApplePayButton = false
                AmplifyEventBus.$emit('setJourney', {key:"checkout",value:"hideAppleButton"} )
            },
            hideManualPayButton:function(){
                console.log("hideManualPayButton")
                this.applePayButtonOn = true
                this.showManualPayButton = false
                this.showApplePayButton = true
                AmplifyEventBus.$emit('setJourney', {key:"checkout",value:"hideManualPayButton"} )
            },
            setService:function(name){
                for(let i in this.selectDisplay.service.color){
                    if(i == name){
                        this.selectDisplay.service.color[i] = 'orange'
                    }else{
                        this.selectDisplay.service.color[i] = 'default'
                    }
                }
                logger.info(this.selectDisplay)
                this.userSelect.service.name = name
                switch(name){
                    case "adt":
                        this.userSelect.service.langName = "お車にお届け"
                        break;
                    case "pickUp":
                        this.userSelect.service.langName = "お持ち帰り"
                        break;
                    case "dineIn":
                        this.userSelect.service.langName = "店内予約"
                        break;
                }
                this.panel = 1
                //.adt

            },
            currentUserSelect:function (userSelect) {
                this.userSelect = userSelect
            }

        },
    }
</script>

<style>
    h1.smaller{
        font-size:1.8em;
    }
    .v-btn__content {
        flex-direction: column;
    }
    #el-cardnumber,#el-exp,#el-cvc{
        border-bottom:1px solid #cccccc;
    }

</style>